import comp from "./InsightCountInfo";
export default comp;
